import { tagsNewOptions } from "../tags-new.js";
import { Container } from "./styles-type-2.js";
import { isRecentRelease } from "./verify-release.js";

export default function MovieType2({ movie }) {

    const newTag = tagsNewOptions.find(obj => obj.value === String(movie?.tag_new))?.label

    return (
        <Container to={`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}`} background_color_hover={movie?.background_color}>
            <div className="div-image">
                <img src={`https://image.tmdb.org/t/p/w400${movie?.backdrop_path}`} alt={movie?.title || movie?.name} loading="lazy"/>
                {movie?.tag_new && (
                    <div className="new-release-banner">{newTag}{}</div>
                )}
            </div>
            <h2>{movie?.title || movie?.name}</h2>
        </Container>
    );
}
